import {ChangeEvent, LegacyRef, FocusEvent, CSSProperties} from "react"

export type PptInputTailwindProps = {
  labelText?: string
  name?: string
  id?: string
  type?: string
  onChange?: ((event: ChangeEvent<HTMLInputElement>) => void)
  value?: string
  placeholder?: string
  className?: string
  pattern?: string
  autoComplete?: string
  onBlur?: ((event: FocusEvent<HTMLInputElement>) => unknown),
  inputRef?: LegacyRef<any> | null
  labelClassName?: string
  inputClassName?: string
  defaultValue?: string
  required?: boolean
  style?: CSSProperties
}

export default function PptInputTailwind(
  props: PptInputTailwindProps
): JSX.Element {
  const {
    className = "",
    id = "",
    name = "",
    labelClassName = "",
    inputClassName = "",
    placeholder = "",
    labelText = "Input",
    type = "text",
    value,
    defaultValue,
    onBlur,
    onChange,
    inputRef = null,
    autoComplete = "",
    required = false,
  } = props
  return (
    <label
      className={className + " flex flex-col items-start justify-start"}
      id={id}
      htmlFor={name}
      style={props.style}
    >
      <span className={labelClassName + " ml-2 text-xs opacity-75"}>
        {labelText}
      </span>
      <input
        name={name}
        value={inputRef ? undefined : value} // allows for uncontrolled input
        onChange={onChange}
        className={
          inputClassName +
          " p-2 text-lg bg-ppt-gray-200 box-shadow-subtle" +
          " border-r-8 border-ppt-blue" +
          " text-black"
        }
        defaultValue={defaultValue && inputRef ? defaultValue : undefined}
        onBlur={onBlur}
        ref={inputRef}
        autoComplete={autoComplete}
        type={type}
        placeholder={placeholder}
        required={required}
      ></input>
    </label>
  )
}